// extracted by mini-css-extract-plugin
module.exports = {"loadButton":"WithButtonLoadingIndicatorHOC-loadButton","load":"WithButtonLoadingIndicatorHOC-load"};